// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogProductEditForm from "../../modules/Catalog/CatalogProductEditForm.res.js";
import * as CatalogProductEditPage from "./CatalogProductEditPage.res.js";
import * as CatalogProductEdit__Config from "./CatalogProductEdit__Config.res.js";
import * as CatalogProductEdit__Queries from "./CatalogProductEdit__Queries.res.js";
import * as CatalogPlaceholderShopPicker from "../../modules/Catalog/CatalogPlaceholderShopPicker.res.js";

function CatalogProductEditContainer(props) {
  let mode = props.mode;
  let cku = props.cku;
  let match = CatalogProductEdit__Queries.ProductsQuery.useLazy(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let productsQueryResults = match[1];
  let executeProductsQuery = match[0];
  let match$1 = CatalogProductEdit__Queries.ProductQuery.useLazy(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let executeProductQuery = match$1[0];
  let onGoBack = Navigation.useGoBack()[1];
  let notifier = Notifier.use("KeepOnHistoryChanges", undefined);
  let shops = Auth.useShops();
  let activeShop = Auth.useActiveShop();
  let activeShopId = Stdlib_Option.map(activeShop, shop => shop.id);
  React.useEffect(() => {
    if (cku !== undefined && shops.length > 1) {
      executeProductsQuery(undefined, undefined, CatalogProductEdit__Queries.ProductsQuery.makeVariables(CatalogProductEdit__Queries.ProductsQuery.makeInputObjectInputProductsQueryFilter(undefined, undefined, undefined, undefined, CatalogProductEdit__Queries.ProductsQuery.makeInputObjectInFilter([cku], undefined), undefined, "INCLUDED", undefined)));
    }
  }, []);
  let disabledShopIds = React.useMemo(() => {
    if (productsQueryResults.TAG !== "Executed") {
      return [];
    }
    let match = productsQueryResults._0.data;
    if (match === undefined) {
      return [];
    }
    let products = match.products.edges;
    return Stdlib_Array.filterMap(shops, param => {
      let id = param.id;
      let match = products.find(param => param.node.shop.id === id);
      if (match !== undefined) {
        return;
      } else {
        return id;
      }
    });
  }, [productsQueryResults]);
  let renderShopSelectionItem = React.useCallback(param => {
    let item = param.item;
    if (item.TAG !== "Option") {
      return null;
    }
    let value = item.value;
    let shopName = Stdlib_Option.mapOr(value, "", shop => shop.name);
    let match = Stdlib_Option.isSome(value);
    let match$1 = Stdlib_Option.getOr(item.disabled, false);
    if (match) {
      if (match$1) {
        return JsxRuntime.jsxs(Inline.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: shopName,
              variation: "placeholder"
            }),
            JsxRuntime.jsx(Inline.make, {
              children: JsxRuntime.jsx(TextStyle.make, {
                children: I18n.t("Non existing product"),
                variation: "subdued",
                size: "xsmall",
                lineHeight: "large"
              }),
              align: "end",
              grow: true
            })
          ],
          align: "spaceBetween",
          alignY: "top",
          grow: true
        });
      } else {
        return JsxRuntime.jsx(TextStyle.make, {
          children: shopName
        });
      }
    } else {
      return JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("Select a shop"),
        variation: "normal"
      });
    }
  }, []);
  React.useEffect(() => {
    if (mode !== "Create") {
      if (activeShop !== undefined && cku !== undefined) {
        executeProductQuery(undefined, undefined, CatalogProductEdit__Queries.ProductQuery.makeVariables(Scalar.CKU.serialize(cku), CatalogProductEdit__Config.makeFilterBy(activeShopId), undefined));
      }
    }
  }, [activeShopId]);
  let onSubmitSuccess = React.useCallback(message => {
    notifier.reset({
      TAG: "Success",
      _0: Stdlib_Option.getOr(message, "")
    }, undefined, undefined);
    onGoBack();
  }, []);
  let onSubmitFailure = React.useCallback(message => notifier.reset({
    TAG: "Error",
    _0: message
  }, undefined, undefined), []);
  let results = CatalogProductEdit__Config.use(match$1[1]);
  let tmp;
  if (typeof results !== "object") {
    tmp = results === "Error" ? JsxRuntime.jsx(Placeholder.make, {
        status: "Error"
      }) : JsxRuntime.jsx(Placeholder.make, {
        status: "Loading"
      });
  } else {
    let match$2 = results._0;
    let contextData = match$2.contextData;
    tmp = JsxRuntime.jsx(CatalogProductEditForm.Core.LegacyProvider.make, {
      initialValues: match$2.initialValues,
      schema: CatalogProductEditForm.schema,
      children: JsxRuntime.jsx(CatalogProductEditPage.make, {
        shopName: match$2.shopName,
        editionMode: mode === "Edit",
        productKind: match$2.productKind,
        contextData: contextData
      }),
      id: Stdlib_Option.map(contextData, param => param.id),
      onSubmitFailure: onSubmitFailure,
      onSubmitSuccess: onSubmitSuccess
    });
  }
  return JsxRuntime.jsx(CatalogPlaceholderShopPicker.make, {
    children: tmp,
    message: I18n.template(I18n.t("Please select the shop in which you would like to {{action}} the reference."), {
      action: I18n.t(mode === "Edit" ? "edit" : "create")
    }, undefined),
    disabledIds: disabledShopIds,
    renderItem: renderShopSelectionItem
  });
}

let make = React.memo(CatalogProductEditContainer);

let Config;

let ProductsQuery;

let ProductQuery;

export {
  Config,
  ProductsQuery,
  ProductQuery,
  make,
}
/* make Not a pure module */
